import http, { endpoints } from '../http';
import { mapNewsFromDto } from './helpers';
const efktClient = http.createClient(endpoints.efkt);
/**
 * **NOT WIRED UP — kept for a future iteration.** News stays on datahub for v2: it is CMS content,
 * not per-record migrated data, so it was taken out of the Efkt migration entirely (meeting
 * 2026-09-22). `v2/modules/news/hooks.ts` calls `datahub.NewsApi` only. Leave this class here and
 * un-called; point the hook at it when news is actually migrated.
 */
export default class NewsApi {
    /**
     * `GET /api/news/language/{languageCode}`, anonymous. No `getNewsById` — a caller resolves a
     * single article by scanning its own already-fetched list instead of issuing a second request.
     */
    static async getTopNews(locale, numberOfNews = 3) {
        let language = 'EN';
        if (locale.includes('da') || locale.includes('dk'))
            language = 'DA';
        if (locale.includes('sv') || locale.includes('se'))
            language = 'SV';
        if (locale.includes('no'))
            language = 'NO';
        if (locale.includes('vi'))
            language = 'VI';
        const response = await efktClient.get(`/api/news/language/${language}?numberOfNews=${numberOfNews}`);
        return response.data.map(mapNewsFromDto);
    }
}
